/* eslint-disable no-console */
import { Logger, AdditionalInfo } from './Logger';

export function createLocalhostLogger(): Logger {
    const { site } = window.appConfig;

    return {
        logInfo: (message, additionalInfo?: AdditionalInfo) => {
            console.log(message, additionalInfo);
        },
        logException: (error: Error, additionalInfo?: AdditionalInfo) => {
            console.error(error, {
                client: site,
                ...additionalInfo
            });
        }
    };
}
